import React from "react";
import { useQuery } from "@apollo/react-hooks";
import Loading from "../Loading";
import Error from "../Error";

const withQuery = (query, options) => Component => props => {
  const { loading, error, data, ...rest } = useQuery(query, options);

  if (loading) {
    return <Loading />;
  }
  if (error) {
    console.log("Error querying data with Apollo:", error.message);
    return <Error />;
  }

  return <Component data={data} queryOps={rest} {...props} />;
};

export default withQuery;
